export const LOGO_URL =
  "/rs-new-logo.png";

export const ADMIN_LOGIN_PATH = "/admin/dibakar/howlader/ceo/mailk/admin/ceodibakarhowlader/engineer";
export const LEGACY_ADMIN_LOGIN_PATH = "/admin/login";

export const STATUS_STEPS = [
  { key: "sourced", label: "Sourced" },
  { key: "processing", label: "Processing" },
  { key: "in_transit", label: "In Transit" },
  { key: "customs", label: "Customs" },
  { key: "out_for_delivery", label: "Out for Delivery" },
  { key: "delivered", label: "Delivered" },
];

export const STATUS_LABEL = {
  sourced: "Sourced",
  processing: "Processing",
  in_transit: "In Transit",
  customs: "Customs Clearance",
  out_for_delivery: "Out for Delivery",
  delivered: "Delivered",
  delayed: "Delayed",
};

export const STATUS_PROGRESS = {
  sourced: 10,
  processing: 25,
  in_transit: 55,
  customs: 75,
  out_for_delivery: 90,
  delivered: 100,
  delayed: 65,
};

export const STATUS_COLOR = {
  sourced: "navy",
  processing: "purple",
  in_transit: "purple",
  customs: "purple",
  out_for_delivery: "purple",
  delivered: "green",
  delayed: "red",
};
